import { render } from "./FilterTabs.vue?vue&type=template&id=25184b14&scoped=true&ts=true"
import script from "./FilterTabs.vue?vue&type=script&lang=ts"
export * from "./FilterTabs.vue?vue&type=script&lang=ts"

import "./FilterTabs.vue?vue&type=style&index=0&id=25184b14&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25184b14"]])

export default __exports__